import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/Dynamic",
          name: "Dynamic",
          component: resolve => require(["@/view/Dynamic"], resolve),
          meta: {
            title: "行业动态"
          }
        },
        {
          path: "/Promotion",
          name: "Promotion",
          component: resolve => require(["@/view/Promotion"], resolve),
          meta: {
            title: "多平台推广"
          }
        },
        {
          path: "/NeedYou",
          name: "NeedYou",
          component: resolve => require(["@/view/NeedYou"], resolve),
          meta: {
            title: "我们需要你"
          }
        },
        {
          path: "/Distribute",
          name: "Distribute",
          component: resolve => require(["@/view/Distribute"], resolve),
          meta: {
            title: "一键分发"
          }
        },
        {
          path: "/AboutUs",
          name: "AboutUs",
          component: resolve => require(["@/view/AboutUs"], resolve),
          meta: {
            title: "关于听海"
          }
        },
        {
          path: "/DynamicDetail",
          name: "DynamicDetail",
          component: resolve => require(["@/view/DynamicDetail"], resolve),
          meta: {
            title: "相关资讯"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js